module.exports = __webpack_public_path__ + "static/media/mapping-consumer-data-img-004.3a45dac7.jpg";